import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(3, 0, 5, 0),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.blue['50'],
    boxShadow: 'none',
    width: 'inherit',
  },
  header: {
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: theme.spacing(3),
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
  showEventsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
